<template>
    <div class="activity">
        <div class="title">活动数据</div>
        <div class="searchBox usreSearchBox">
            <el-select v-model="provinceId" class="selectBox" size="large" filterable placeholder="活动名称" @change="getDetails" clearable @clear="clearVal('provinceId')">
                <el-option v-for="item in activityList" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
        </div>
        <div class="searchBox">
            <el-select v-model="ticketId" class="selectBox" size="large" filterable placeholder="票种名称" @change="getTicket" clearable @clear="clearVal('provinceId')">
                <el-option v-for="item in ticketData" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </div>
        <div class="detailsBox">
            <div class="details detailsFirst">
                <p class="name">{{activityDetails.title}}</p>
                <div class="detailsContent">
                    <img :src="activityDetails.cover" class="pic" alt="">
                    <div class="contentBox" :class="{'noTicket': activityDetails.isTicket == 0}">
                        <div class="contentItem">
                            <span class="label">选手人数：</span>
                            <span class="value">{{activityDetails.playerTotal}}</span>
                        </div>
                        <div class="contentItem">
                            <span class="label">观众人数：</span>
                            <span class="value">{{activityDetails.audienceTotal}}</span>
                        </div>
                        <div class="contentItem">
                            <span class="label">举办时间：</span>
                            <span class="value">{{activityDetails.startTime | formatDate}} 至 {{activityDetails.endTime | formatDate}}</span>
                        </div>
                        <div class="contentItem">
                            <span class="label">地点：</span>
                            <span class="value">{{activityDetails.cityName}}</span>
                        </div>
                        <div class="contentItem">
                            <span class="label">级别：</span>
                            <span class="value">{{activityDetails.activityLevel}}</span>
                        </div>
                        <div class="contentItem p" v-if="activityDetails.isTicket == 1">
                            <span class="label">售票进度：</span>
                            <div class="con">
                                <span class="value">{{`${activityDetails.sellTicketCount}/${activityDetails.allTicketCount} (${Math.round(activityDetails.sellTicketCount / activityDetails.allTicketCount * 10000) / 100.00}%售票率)`}}</span>
                                <div class="progressBox clear">
                                    <span class="progress fl" :style="`width: ${Math.round(activityDetails.sellTicketCount / activityDetails.allTicketCount * 10000) / 100.00}%`"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="details userBox">
                <user ref="useBox"></user>           
            </div>
        </div>
    </div>
</template>

<script>
import bigData from '@/services/bigData'
import user from './user'
export default {
    components: { user },
    data() {
        return {
            provinceId: '',
            ticketId: 16,
            ticketData: [
                {
                    label: '观众票',
                    value: 16
                }, {
                    label: '授课票',
                    value: 17
                }, {
                    label: '选手票',
                    value: 18
                }
            ],
            activityList: [],
            activityDetails: {}
        }
    },
    created() {
        this.getActivityList()
    },
    methods: {
        getActivityList() {
            bigData.searchActivity({ key: '' }).then(res => {
                if (res.code == 0 ) {
                    this.activityList = res.result;
                    this.provinceId = res.result[0].id;
                    this.getDetails()
                }
            })
        },
        getDetails() {
            bigData.activityDetails(this.provinceId).then(res => {
                if (res.code == 0) {
                    this.activityDetails = res.result;
                    this.getTicket()
                }
            })
        },
        getTicket() {
            let data = {
                activityId: this.provinceId,
                ticketTypeId: this.ticketId
            }
            bigData.ticket(data).then(res => {
                this.$nextTick(() => {
                    this.$refs.useBox.setData(res)
                })
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.title{
    margin-top: 24px;
    color: #fff;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 13px;
}
.selectBox{
    border-radius: 12px;
    overflow: hidden;
}
.searchBox{
    box-sizing: border-box;
    display: inline-block;
}
.usreSearchBox{
    float: left;
    width: 784px;
}
::v-deep .el-input__inner{
    background-color: #151522;
    border: none;
    color: #a1a1cc;
}
.el-scrollbar{
    background-color: #151522;
    color: #fff;
}
.detailsBox{
    margin-top: 16px;
    display: flex;
}
.details{
    background-color: #292941;
    border-radius: 12px;
    padding: 24px;
    box-sizing: border-box;
    .name{
        font-size: 24px;
        line-height: 33px;
        color: #fff;
        margin-bottom: 24px;
    }
}
.detailsFirst{
    min-width: 774px;
}
.detailsContent{
    display: flex;
    .pic{
        width: 205px;
        height: 272px;
        margin-right: 19px;
    }
    .contentBox{
        flex: 1;
    }
    .contentItem{
        font-size: 16px;
        line-height: 22px;
        overflow: hidden;
        margin-bottom: 24px;
    }
    .contentItem:last-child{
        margin-bottom: 0;
    }
    .label{
        color: #A1A1CC;
        width: 80px;
        float: left;
        text-align: left;
        margin-right: 18px;
    }
    .value{
        color: #fff;
        float: left;
    }
}
.noTicket .contentItem{
    margin-bottom: 40px;
}
.userBox{
    margin-left: 10px;
    flex: 1;
}
.progressBox{
    width: 100%;
    float: left;
    height: 10px;
    background-color: #4D4D7D;
    border-radius: 8.5px;
    margin-top: 8px;
    overflow: hidden;
    .progress{
        height: 100%;
        background: linear-gradient(132deg, #54A2FF 0%, #5854FF 100%);
        display: inline-block
    }
}
.p{
    display: flex;
    .label{
        line-height: 40px;
    }
    .con{
        flex: 1;
    }
}
::v-deep .el-input__inner::placeholder {
  color: #A1A1CC;
}
/* 谷歌 */
::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #A1A1CC;
}
/* 火狐 */
::v-deep .el-input__inner:-moz-placeholder {
  color: #A1A1CC;
}
/*ie*/
::v-deep .el-input__inner:-ms-input-placeholder {
  color: #A1A1CC;
}
</style>
